import { forwardRef, useContext } from 'react';
import ReactDatePicker from 'react-datepicker';
import cls from 'classnames';
import { FormContext, FormLabel } from '../FormElements';
import './index.scss';

const defaultOnChange = () => { };

const CustomInput = forwardRef(({ error, ...restProps }, ref) => (
    <>
        <input
            {...restProps}
            ref={ref}
            type="text"
        />

        {Boolean(error) && (
            <small className="invalid-feedback text-danger">
                {error}
            </small>
        )}
    </>
));

export const DatePicker = ({
    id,
    label,
    name,
    selected,
    required = false,
    formGroupClassName = '',
    className = '',
    error,
    onChange = defaultOnChange,
    ...restProps
}) => {
    const context = useContext(FormContext);

    let fieldValue = selected;
    let fieldOnChange = onChange;

    if (context && context.values) {
        fieldValue = context.values[name || id];
        fieldOnChange = (e, v) => {
            onChange(e, v);
            context.onChange(e, v);
        };
    }

    return (
        <div className={cls('form-group', formGroupClassName)}>
            {Boolean(label) && (
                <FormLabel
                    htmlFor={id}
                    text={label}
                    required={required}
                />
            )}

            <ReactDatePicker
                id={id}
                className={cls('form-control', className)}
                name={name}
                required={required}
                selected={fieldValue}
                autoComplete="off"
                onChange={(dateValue, event) => {
                    const newEvent = {
                        ...(event || {}),
                        target: {
                            ...(event?.target || {}),
                            name: event?.target?.name || name,
                            value: dateValue,
                        },
                    };

                    fieldOnChange(newEvent, dateValue);
                }}
                customInput={<CustomInput error={error} />}
                {...restProps}
            />
        </div>
    );
};